import { Component } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import {AuthService} from "../../models/auth/auth.service";


@Component({
    selector: 'enter-by-token',
    templateUrl: 'enter.by.token.html'
})
export class EnterByTokenComponent {
    constructor(private router: Router,
                private route: ActivatedRoute,
                private authService: AuthService) {

        this.route.params.subscribe(params => {
            if (params['token']) {
                this.authService.enterBy(params['token'])
                    .then(() => {
                        this.router.navigate(['/']);
                    })
                    .catch((error) => {
                        this.toLoginPage();
                    });
                return;
            }
            this.toLoginPage();
        });
    }

    toLoginPage() {
        this.router.navigate(['/']);
    }

}




// WEBPACK FOOTER //
// ./src/app/views/enter-by-token/enter.by.token.component.ts